import { createAction } from "@reduxjs/toolkit";
import { isEqual } from "lodash";
export function restoreState(state, payload, slice) {
    if (!isEqual(state, payload.fileBrowser[slice])) {
        return payload.fileBrowser[slice];
    }
}
export const resetAllSlices = createAction("RESET_ALL_SLICES");
//# sourceMappingURL=utils.js.map